
import React from 'react';
import { Button } from '@/components/ui/button';
import { Separator } from '@/components/ui/separator';

interface SearchResultsHeaderProps {
  searchTerm: string;
  resultsCount: number;
  onClearSearch: () => void;
}

const SearchResultsHeader = ({ searchTerm, resultsCount, onClearSearch }: SearchResultsHeaderProps) => {
  return (
    <div className="mb-6">
      <Separator className="mb-6" />
      <div className="flex justify-between items-center">
        <h2 className="text-xl font-medium text-redflags-dark">
          {resultsCount > 0 
            ? `Companies matching "${searchTerm}" (${resultsCount})`
            : `No companies found for "${searchTerm}"`}
        </h2>
        <Button 
          variant="outline" 
          onClick={onClearSearch}
          className="border-redflags-red text-redflags-red hover:bg-redflags-red/5"
        >
          Clear search
        </Button>
      </div>
    </div>
  );
};

export default SearchResultsHeader;
